import React from 'react';
import { classNames } from '../../utils/formatters';

/**
 * Accessible icon-only button. An `aria-label` (or `aria-labelledby`) is required because
 * the visible content is non-textual; we warn in development if it is missing.
 *
 * Minimum 44x44px hit target to satisfy touch accessibility guidelines.
 */
const IconButton = React.forwardRef(function IconButton(
  { label, onClick, type = 'button', className, children, ...rest },
  ref,
) {
  if (
    process.env.NODE_ENV !== 'production' &&
    !label &&
    !rest['aria-label'] &&
    !rest['aria-labelledby']
  ) {
    // eslint-disable-next-line no-console
    console.warn('IconButton: provide a `label` so screen readers can announce it.');
  }

  return (
    <button
      ref={ref}
      type={type}
      onClick={onClick}
      aria-label={label}
      className={classNames(
        'inline-flex items-center justify-center min-w-[44px] min-h-[44px] rounded-lg',
        'text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
});

export default IconButton;
